<ion-content>
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-icon class="large" name="close" color="danger"></ion-icon>

        <h2 class="ion-margin-top">Unfortunately, we cannot proceed with your payment !</h2>
        <p class="ion-margin-top">Please, try again to place order</p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
